<template>
  <el-dialog :title="$t('viewPayFeeBatch.title')" :visible.sync="visible" width="75%" @close="handleClose">
    <div class="batch-info">
      <span>{{ $t('viewPayFeeBatch.batchId') }}：<b>{{ batch ? batch.batchId : '' }}</b></span>
      <span v-if="total > 0" class="batch-total">
        {{ $t('viewPayFeeBatch.total') }}：<b>{{ total }}</b> {{ $t('viewPayFeeBatch.unit') }}
      </span>
    </div>

    <el-table :data="fees" border v-loading="loading" style="width: 100%; margin-top: 10px">
      <el-table-column prop="feeId" :label="$t('viewPayFeeBatch.feeId')" align="center" min-width="150" />
      <el-table-column prop="payerObjName" :label="$t('viewPayFeeBatch.room')" align="center" min-width="120" />
      <el-table-column prop="feeName" :label="$t('viewPayFeeBatch.feeItem')" align="center" min-width="120" />
      <el-table-column :label="$t('viewPayFeeBatch.period')" align="center" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.startTime }} ~ {{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('viewPayFeeBatch.amount')" align="center">
        <template slot-scope="scope">
          {{ scope.row.amount == -1 ? $t('viewPayFeeBatch.periodicFee') : scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column prop="stateName" :label="$t('viewPayFeeBatch.state')" align="center" />
    </el-table>

    <el-pagination class="pagination" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-size="pageSize" layout="total, prev, pager, next" :total="total" />
  </el-dialog>
</template>

<script>
import { listFee } from '@/api/fee/propertyFeeApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'ViewPayFeeBatch',
  data() {
    return {
      visible: false,
      loading: false,
      batch: null,
      fees: [],
      total: 0,
      currentPage: 1,
      pageSize: 10
    }
  },
  methods: {
    open(batch) {
      this.batch = batch
      this.currentPage = 1
      this.total = 0
      this.fees = []
      this._loadFees(1, this.pageSize)
      this.visible = true
    },
    async _loadFees(page, row) {
      if (!this.batch) return
      this.loading = true
      try {
        const params = {
          page,
          row,
          communityId: getCommunityId(),
          batchId: this.batch.batchId
        }
        const res = await listFee(params)
        this.fees = res.fees || []
        this.total = res.total || 0
      } catch (error) {
        console.error('加载批次费用明细失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._loadFees(val, this.pageSize)
    },
    handleClose() {
      this.fees = []
      this.batch = null
      this.total = 0
      this.currentPage = 1
    }
  }
}
</script>

<style scoped>
.batch-info {
  display: flex;
  gap: 30px;
  align-items: center;
  font-size: 14px;
  color: #303133;
}

.batch-total {
  color: #606266;
}

.pagination {
  margin-top: 15px;
  text-align: right;
}
</style>
